/* eslint-disable max-len */
import React from 'react';
import { SvgIcon } from 'components/SvgIcon';
import { IThankYou } from 'services/ThankYouService';
import { enPaymentMethod } from 'enums/enPaymentMethod';

interface IProps {
  model: IThankYou;
}

const Info: React.FC<IProps> = ({ model }) => {
  const textInformation = {
    [enPaymentMethod.BANKSLIP]: (
      <p>
        Este é um produto digital, assim que o boleto for pago faremos a entrega do seu conteúdo no seu <b>e-mail</b>. Enquanto isso, confirme osseus
        dados.
      </p>
    ),
    [enPaymentMethod.PAGDIVIDIDO]: (
      <p>
        Este é um produto digital. Fique atento, você receberá um <b>SMS</b> para finalizar o processo. Após finalizado o conteúdo estará disponível
        no seu&nbsp;
        <b>e-mail</b>.
      </p>
    )
  };
  return (
    <React.Fragment>
      &nbsp;
      <div className="message">
        {textInformation[model.paymentResult.paymentMethod] ?? (
          <p>
            Este é um produto digital, estamos preparando com carinho a entrega do seu conteúdo no seu <b>e-mail</b>. Enquanto isso, confirme os seus
            dados.
          </p>
        )}
      </div>
      <div className="data">
        <div className="user">
          <p>
            <SvgIcon name="user" />
            <span>{model.studdent ? model.studdent.name : model.user.name}</span>
          </p>
          <p>
            <SvgIcon name="email" />
            <span>{model.studdent ? model.studdent.email : model.user.email}</span>
          </p>
        </div>
      </div>
      <div className={'alert'}>
        Em caso de dúvidas, ou se você precisar de suporte, entre em contato com o vendedor pelo e-mail <b>{model.content.producerEmail}</b>.
      </div>
    </React.Fragment>
  );
};

export default React.memo(Info);
